import { useMutation } from '@/react-query/hooks/useMutation/useMutation';
import { chargesQueries, ChargeType } from '@/services/charges/charges.queries';
import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

const useToggleChargeStatus = (activeTab: ChargeType) => {
  const queryClient = useQueryClient();
  const { mutateAsync, isPending } = useMutation('toggleStatusCharge', {
    onSuccess: async (res) => {
      await queryClient.invalidateQueries({ queryKey: chargesQueries.all(activeTab) });
      toast.success(res.message);
    },
    onError: (error) => {
      toast.error(error.message);
    },
  });

  return { mutateAsync, isPending };
};

export default useToggleChargeStatus;
